import { IDefineCommand, IQuery } from 'core-ts-types';
import { IInTakeSurveyQuestionMeta } from '../builders/ap_intake_survey_builder';
import { PollServant } from '../servants/poll_servant';
angular
  .module('capability-ng-academic-planner')
  .service(
    'saveMultipleQuestionAnswerCommand',
    function saveMultipleQuestionAnswerCommand(
      defineCommand: IDefineCommand,
      saveInTakeSurveyAnswerCommand: any,
      log: any,
      $q: ng.IQService
    ) {
      return defineCommand(
        'saveMultipleQuestionAnswerCommand',
        (deferred: ng.IDeferred<IQuery[]>, questions: IInTakeSurveyQuestionMeta[]) => {
          const mappedQuesAndAns = PollServant.getQuestionAndAnswerMappedForApi(questions);
          $q.all(questions.map((question) => saveInTakeSurveyAnswerCommand(question.id, mappedQuesAndAns[question.id])))
            .then(() => {
              deferred.resolve();
            })
            .catch((e: string) => {
              log.issue('saveMultipleQuestionAnswerCommand failed');
              deferred.reject(e);
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/preferences/components/intake_survey/commands/save_multiple_question_answer_command.ts